import './DepartmentContactBlock.scss';
import { AlertBox, Icon } from '@gplibraries/react/components';
import { useConfig } from '@gplibraries/react/hooks';
import { Link } from 'react-router';
import { StringFormatter } from '@gplibraries/utils';

export default function DepartmentContactBlock({ departmentId }) {

  const departmentContacts = useConfig('departmentContacts');
  const contact = departmentContacts.find(contact => contact.categoryId === departmentId);

  if (!contact) return null;

  return (
    <AlertBox className={'department-contact-block'}>
      <strong>{`Contact ${contact.departmentLabel}: `}</strong>
      {contact.phone &&
        <Link to={`tel:${StringFormatter.phone(contact.phone)}${contact?.extension ? 'p' + contact.extension : ''}`}>
          <Icon glyph={'telephone-fill'}/>
          {contact?.extension
            ? contact.phone + ' ext. ' + contact.extension
            : contact.phone
          }
        </Link>
      }
      {contact.email &&
        <Link to={`mailto:${contact.email}`}>
          <Icon glyph={'envelope-at-fill'}/>
          {contact.email}
        </Link>
      }
    </AlertBox>
  );

}